import React, { memo, ReactElement } from "react";
import { useTheme } from "styled-components";

const CreditScoreSvg = (): ReactElement => {
    const theme = useTheme();

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <mask
                id="mask0_39649_45383"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill={theme.colors[theme.colorMode].background_inverse_Primary} />
            </mask>
            <g mask="url(#mask0_39649_45383)">
                <path
                    d="M4 8.404H20V6.30775C20 6.23075 19.9679 6.16025 19.9038 6.09625C19.8398 6.03208 19.7693 6 19.6923 6H4.30775C4.23075 6 4.16025 6.03208 4.09625 6.09625C4.03208 6.16025 4 6.23075 4 6.30775V8.404ZM2.5 6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V11.596H4V17.6923C4 17.7692 4.03208 17.8398 4.09625 17.9038C4.16025 17.9679 4.23075 18 4.30775 18H8.6865V19.5H4.30775C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775ZM14.7962 21.2693L10.8923 17.3652L11.9462 16.3115L14.7962 19.1307L20.4653 13.4615L21.5193 14.546L14.7962 21.2693ZM4 6.30775V17.6923C4 17.7692 4.03208 17.8398 4.09625 17.9038C4.16025 17.9679 4.23075 18 4.30775 18H4V13.4713V16.3058V6H4.30775C4.23075 6 4.16025 6.03208 4.09625 6.09625C4.03208 6.16025 4 6.23075 4 6.30775Z"
                    fill={theme.colors[theme.colorMode].background_inverse_Primary}
                    fillOpacity="0.6"
                />
            </g>
        </svg>
    );
};

export default memo(CreditScoreSvg);
